import { AxiosProgressEvent } from 'axios';
import { PresignedUploadResult, uploadPresignedFile } from 'utils/upload/presignedUpload';
import { PresignedUploadParams } from 'utils/upload/types';

export function uploadPresigned(
  blob: Blob,
  params: PresignedUploadParams,
  signal: AbortSignal,
  onUploadProgress?: (event: AxiosProgressEvent) => void
): Promise<PresignedUploadResult> {
  return uploadPresignedFile(
    blob,
    {
      storageUrl: params.storageUrl,
      callbackUrl: params.callbackUrl,
      callbackToken: params.callbackToken,
      callbackBody: { size: blob.size, ...params.callbackBody },
    },
    { signal, onUploadProgress }
  );
}
